/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_EnrollmentsInputs */

const en__field_enrollments = /** @type {(inputs: _Field_EnrollmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrollments`)
};

/**
* | output |
* | --- |
* | "Enrollments" |
*
* @param {_Field_EnrollmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_enrollments = /** @type {((inputs?: _Field_EnrollmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_EnrollmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_enrollments(inputs)
});